<script setup lang="ts">
import InstallmentCard from './InstallmentCard.vue'

const props = defineProps<{
  defaultListOfInstallments: any
  disableFields: any
}>()

const { formatMoney } = useMoney()

const selectedInstallment = computed(() => {
  return props.defaultListOfInstallments && props.defaultListOfInstallments.length > 0
    ? props.defaultListOfInstallments[0]
    : null
})

const installmentType = computed(() => {
  if (!selectedInstallment.value) return ''
  return selectedInstallment.value.type || ''
})

const isComboConecte = computed(() => installmentType.value === 'Combo Conecte')
const isComboFacil = computed(() => installmentType.value === 'Combo Fácil' || installmentType.value === 'combo')
const isWithoutCombo = computed(() => !isComboConecte.value && !isComboFacil.value)

const cardTitle = computed(() => {
  if (isComboConecte.value) return 'Combo Conecte'
  if (isComboFacil.value) return 'Combo Fácil'
  return 'Parcelamento Comum'
})

const cardPoints = computed(() => {
  if (isWithoutCombo.value) return 'Ganhe 30.000 pontos'
  return 'Ganhe 150.000 pontos'
})

const cardStoreInfo = computed(() => {
  if (isWithoutCombo.value) return 'Em qualquer loja'
  return 'Somente na Loja Solfácil'
})
</script>

<template>
  <div v-if="!props.disableFields && selectedInstallment" class="finished-project-wrapper">
    <InstallmentCard
      :disabled="true"
      :economy="formatMoney(selectedInstallment.reducedInstallmentPrice || 0)"
      :has-link="isComboConecte"
      link-text="Consulte regras aplicáveis"
      :points="cardPoints"
      :price="formatMoney(selectedInstallment.installments_value || 0)"
      :selected="true"
      :show-best-offer="isComboConecte"
      :store-info="cardStoreInfo"
      :title="cardTitle"
      @select="() => {}"
    />
  </div>
</template>

<style lang="scss" scoped>
.finished-project-wrapper {
  display: flex;
  justify-content: flex-start;
  margin: 24px 0;
  padding-top: 16px;
  padding-bottom: 16px;

  :deep(.installment-card) {
    min-width: 188px;
    max-width: 390px;
    width: 390px;
  }
}
</style>
